import module from './module'
/* Components */
import './components/kd-grid/component'

export default module.name



// WEBPACK FOOTER //
// ./src/kendu/grid/index.js